export default "/images/map.svg?65b9ab83cf598b2123b05a10be997d31";